/**
 * Link rel attribute updates
 *
 * @return {void}
 */
const init = () => {

	/**
	 * Check if an URL is from a specific domain
	 *
	 * @param {string} domain Domain name to check
	 * @param {string} url    URL to check
	 *
	 * @returns {bool}
	 */
	const checkDomain = ( domain, url ) => {
		var test = new RegExp( '^https?://(?:[^/@:]*:[^/@]*@)?(?:[^/:]+\.)?' + domain + '(?=[/:]|$)', 'i' );
		return test.test( url );
	}

	/**
	 * Check if an URL is sponsored
	 *
	 * @param {string} link Link to check
	 *
	 * @returns {bool}
	 */
	const isSponsored = ( link ) => {
		const sponsorDomains = ['amazon.com', 'amazon.co', 'amzn.com', 'amzn.to', 'go.skimlinks.com', 'fave.co'];

		return sponsorDomains.some( domain => checkDomain( domain, link ) );
	}

	/**
	 * Update link rel for sponsored links
	 *
	 * @returns {void}
	 */
	const updateLinkRel = () => {

		// Try to grab all external links from the post content
		const allExternalLinks = document.querySelectorAll( '.post-content a[target="_blank"], .entry-content a[target="_blank"], .article__main a[target="_blank"], .page-general__content a[target="_blank"]' );

		// Grab all sponsored links
		const sponsoredLinks = Array.from( allExternalLinks ).filter( link => isSponsored( link.href ) );

		sponsoredLinks.forEach( link => {
			// Apply rel="sponsored"
			let currentRel = link.rel;

			if ( currentRel ) {
				if ( currentRel.includes( 'noindex' ) ) {
					currentRel = currentRel.replace( 'noindex', '' );
				}

				// If the link doesn't already have a sponsored rel attribute
				if ( ! currentRel.includes( 'sponsored' ) ) {
					// If the current rel has nofollow already, only add sponsored
					if ( currentRel.includes( 'nofollow' ) ) {
						link.setAttribute( 'rel', `${currentRel} sponsored` );
					} else {
						// add nofollow as well
						link.setAttribute( 'rel', `${currentRel} sponsored nofollow` );
					}
				}
			} else {
				link.setAttribute( 'rel', 'sponsored nofollow' );
			}
		} );
	};

	document.addEventListener( 'DOMContentLoaded', updateLinkRel );
};

export default {init};
